module.exports = __webpack_public_path__ + "img/logo-hello-desktop.395f7735.svg";